require.register("modules/m0x/a04/page-35-ny/page-35-ny", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_35_ny = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_35_ny;

  
});

